"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const ListNumbered = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 33.22 33.22",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
  x: "8.136",
  y: "5.506",
  width: "25.084",
  height: "5.1",
  className: "fill"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "8.136",
  y: "13.722",
  width: "25.084",
  height: "5.098",
  className: "fill"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "8.136",
  y: "22.506",
  width: "25.084",
  height: "5.098",
  className: "fill"
}), /*#__PURE__*/_react.default.createElement("polygon", {
  points: "1.519,6.119 1.539,6.119 1.539,11.369 3.038,11.369 3.038,4.74 1.765,4.74 0,5.558 0.255,6.72",
  className: "fill"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M4.61,18.328H2.15v-0.021l0.6-0.5c0.949-0.838,1.73-1.707,1.73-2.799c0-1.182-0.8-2.039-2.279-2.039 c-0.872,0-1.64,0.299-2.121,0.668l0.431,1.082c0.339-0.25,0.831-0.531,1.389-0.531c0.751,0,1.061,0.422,1.061,0.949 c-0.01,0.762-0.7,1.49-2.129,2.77L0,18.656v0.924h4.61V18.328z",
  className: "fill"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M3.305,24.842v-0.02c0.816-0.277,1.213-0.838,1.213-1.541c0-0.908-0.785-1.648-2.192-1.648 c-0.867,0-1.651,0.242-2.049,0.496l0.317,1.123c0.265-0.164,0.835-0.396,1.375-0.396c0.664,0,0.981,0.293,0.981,0.691 c0,0.562-0.654,0.764-1.174,0.764h-0.6v1.111h0.631c0.673,0,1.327,0.297,1.327,0.959c0,0.49-0.409,0.877-1.214,0.877 c-0.632,0-1.265-0.254-1.54-0.408l-0.317,1.174c0.389,0.232,1.113,0.457,1.969,0.457c1.682,0,2.713-0.855,2.713-2.016 C4.745,25.586,4.103,24.982,3.305,24.842z",
  className: "fill"
})));
var _default = exports.default = ListNumbered;